import { render, staticRenderFns } from "./CascadingElementWeightTableColumn.vue?vue&type=template&id=e25b2002"
import script from "./CascadingElementWeightTableColumn.vue?vue&type=script&lang=js"
export * from "./CascadingElementWeightTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CascadingElementWeightTableColumn.vue?vue&type=style&index=0&id=e25b2002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports